import styled from '@emotion/styled';
import { SectionTitle } from '~/shared/components/Summary/components/SectionTitle/SectionTitle';
import { ReceiptData } from '~/lib';
import { RawHtml } from '~/shared/components';
import Button from '~/shared/components/Button';
import Flex from '~/shared/components/Flex';
import { breakpoints } from '~/theme/breakpoints';

type props = {
    data: ReceiptData;
};
export const CustomerService = ({ data }: props) => {
    return (
        <div>
            <Wrapper column alignItems="center">
                <Title>{data.supportHeadline}</Title>
                <Data html={data.supportText} />
                <Button
                    as="a"
                    fullWidth
                    href={data.SupportPhoneButton.url}
                    target={data.SupportPhoneButton.target}
                >
                    {data.SupportPhoneButton.title}
                </Button>
            </Wrapper>
        </div>
    );
};

const Wrapper = styled(Flex)(({ theme }) => ({
    padding: theme.space[3],
    [breakpoints.sm]: {
        padding: `0  ${theme.space[3]} ${theme.space[3]}`,
    },
}));

const Data = styled(RawHtml)(({ theme }) => ({
    color: theme.colors.black,

    textAlign: 'center',
    backgroundColor: 'transparent',
    '> *': {
        ...theme.mixins.useTextStyle('bodySmall'),
        backgroundColor: 'transparent',
    },
}));

const Title = styled(SectionTitle)({
    [breakpoints.sm]: {
        borderTop: 'none',
    },
});
